import { useCookies } from 'react-cookie'
import { useCompanySso } from '../../common/companySso'

export const DATA_RESIDENCY_ENABLED_COOKIE = 'dataResidencyEnabled'

export const useResidencySelection = (): boolean => {
  const [cookies] = useCookies([DATA_RESIDENCY_ENABLED_COOKIE])
  const { shouldUseCompanySso } = useCompanySso()
  const flag = cookies[DATA_RESIDENCY_ENABLED_COOKIE]
  return (flag === true || flag === 'true') && !shouldUseCompanySso()
}
